import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbanialuxuryminibusonrent() {



  const cardData =
  {
    keyword: 'Force Urbania Luxury Mini Bus On Rent',
    heading: 'Amruta Travels: Force Urbania Luxury Mini Bus On Rent',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Force Urbania Luxury Mini Bus on Rent, combining elegance, comfort, and modern performance for group travel. Ideal for corporate trips, airport transfers, weddings, family tours, and outstation journeys, our luxury Urbania minibuses feature plush push-back seats, premium interiors, LED lighting, powerful air conditioning, and ample luggage space to ensure a smooth and enjoyable ride. Each vehicle is driven by a professional chauffeur who ensures punctuality, safety, and courteous service throughout the journey. Whether traveling locally or to destinations like Mumbai, Shirdi, Mahabaleshwar, or Goa, Amruta Travels’ Force Urbania Luxury Mini Bus Rental delivers a world-class travel experience with unmatched comfort, reliability, and style.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic fort, built in 1732 by the Peshwas as their royal residence. Its massive gates, grand courtyards, and legendary stories of bravery make it a living chapter of Maratha history. The light and sound show held in the evening recreates the glorious era of Bajirao and his legacy. Shaniwar Wada is the pride of Pune and a must-visit heritage monument."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this majestic palace is a symbol of India’s freedom struggle. It served as a place of imprisonment for Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu during the Quit India Movement. The museum inside preserves rare photographs and personal belongings of Gandhi. Aga Khan Palace is Pune’s monument of peace, patriotism, and history."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a steep hill, Sinhagad Fort offers stunning views of the Sahyadri ranges and holds a glorious past. It was the site of the legendary battle where Tanaji Malusare fought bravely under the command of Chhatrapati Shivaji Maharaj. The fort’s rustic ruins, memorials, and scenic trails make it a favorite for trekkers. Sinhagad stands as Pune’s eternal symbol of Maratha valor."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dedicated to Lord Ganesha, the Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine. The temple’s magnificent idol adorned with gold and jewels attracts devotees from all over India. During Ganesh Chaturthi, the area comes alive with lights, music, and devotion. It is a spiritual landmark reflecting Pune’s deep-rooted faith and cultural spirit."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers a peaceful retreat with panoramic views of Pune city. The 108-step climb leads to an 18th-century temple dedicated to Lord Shiva and Goddess Parvati, built by the Peshwas. The hill also houses a museum displaying Maratha-era artifacts. Parvati Hill blends serenity, spirituality, and heritage, making it one of Pune’s most scenic viewpoints."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of a single basalt rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. Its circular Nandi mandap and rock pillars showcase the artistry of ancient Indian stone-cut architecture. The cave’s calm atmosphere contrasts beautifully with the city’s bustle. Pataleshwar is Pune’s hidden gem for history and spirituality lovers."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses an extraordinary collection of over 20,000 artifacts curated by Dr. D.G. Kelkar. It displays musical instruments, sculptures, antique furniture, and everyday objects from India’s cultural past. The exhibits reflect the creativity and craftsmanship of different Indian eras. Raja Dinkar Kelkar Museum is Pune’s artistic gateway into India’s rich heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned center for meditation, wellness, and holistic living. Set amid lush greenery, it offers meditation sessions, spa therapies, and personal growth programs. Its tranquil environment attracts seekers from across the globe. The resort embodies Pune’s modern spiritual and international lifestyle."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a scenic reservoir just outside Pune, surrounded by rolling hills and breezy weather. It serves as a popular picnic spot for families and couples who come to enjoy local street food by the lakeside. The sunsets here are mesmerizing and picture-perfect. Khadakwasla is Pune’s favorite escape into nature and calmness."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully designed landscape in Sinhagad Road offers a serene experience. The garden features flowing streams, manicured lawns, and traditional Japanese elements symbolizing peace and balance. Families, photographers, and nature lovers find it a perfect getaway. The Friendship Garden is Pune’s living expression of harmony and cross-cultural beauty."
  }
],



     "services": [
    {
      "name": "Force Urbania Luxury Mini Bus On Rent",
      "description": "Experience top-tier travel with Force Urbania Luxury Mini Bus On Rent, offering spacious, stylish, and fully-equipped mini buses ideal for corporate outings, family trips, and special events. These luxury mini buses boast plush seating, advanced air conditioning systems, and modern amenities to ensure comfort even on long journeys. Regularly maintained for safety and cleanliness, these vehicles come with experienced and professional drivers who prioritize punctuality and passenger convenience. Whether it’s a wedding, corporate travel, or leisure tour, this service guarantees a premium travel experience marked by elegance, reliability, and excellent customer support, making every trip memorable and stress-free."
    },
    {
      "name": "Luxury Urbania Mini Bus Pune",
      "description": "Luxury Urbania Mini Bus Pune is designed for clients seeking an upscale travel option with superior comfort and convenience. Featuring luxurious interiors, ample legroom, and climate control, these mini buses cater perfectly to weddings, corporate events, and family excursions. The vehicles are equipped with modern entertainment systems and safety features, ensuring a relaxed and secure journey. With professional chauffeurs who are courteous and familiar with Pune’s traffic patterns, this service provides timely pickups and drop-offs, flexible booking options, and personalized travel plans that fit your exact needs. Expect a blend of sophistication and practicality in every ride."
    },
    {
      "name": "Force Urbania AC Mini Bus Pune",
      "description": "Force Urbania AC Mini Bus Pune offers a cool, comfortable travel experience with fully air-conditioned mini buses suitable for Pune’s warm climate. Ideal for corporate groups, family tours, and airport transfers, these buses come with efficient AC systems that maintain a refreshing atmosphere throughout the journey. Passengers benefit from spacious seating and smooth rides, thanks to regular vehicle maintenance and skilled drivers who ensure safety and punctuality. The service is tailored to provide hassle-free travel with easy booking, professional customer service, and customizable routes that meet diverse client requirements."
    },
    {
      "name": "Non AC Urbania Mini Bus Pune",
      "description": "For those seeking an economical yet reliable travel option, Non AC Urbania Mini Bus Pune offers well-maintained vehicles without air conditioning. Perfect for short city trips, budget-conscious groups, and quick commutes, these mini buses maintain high standards of cleanliness, safety, and comfort. Drivers are trained to provide courteous and timely service, ensuring a smooth and efficient ride regardless of the absence of AC. This service is ideal for community outings, school trips, and small group travels looking to balance cost with convenience."
    },
    {
      "name": "Urbania Mini Bus Hire Pune",
      "description": "Urbania Mini Bus Hire Pune delivers versatile van rental solutions catering to a variety of travel needs including group outings, business trips, and special events. Featuring a fleet of well-maintained mini buses with seating for multiple passengers, this service emphasizes safety, punctuality, and customer satisfaction. With flexible rental durations, personalized travel plans, and easy online booking, customers enjoy a hassle-free experience. Professional drivers knowledgeable about Pune’s routes guarantee smooth and timely transport whether navigating urban traffic or heading to outstation destinations."
    },
    {
      "name": "Urbania Mini Bus Rental Pune",
      "description": "Urbania Mini Bus Rental Pune is committed to providing reliable and affordable mini bus rentals with a focus on quality and customer service. Suitable for family outings, corporate travels, and tourist excursions, the rental fleet includes vehicles equipped with modern safety features and comfortable seating. Drivers are experienced and courteous, ensuring your journey is pleasant and secure. The service offers flexible packages, 24/7 customer support, and easy online reservation options that cater to the dynamic needs of Pune’s residents and visitors alike."
    },
    {
      "name": "Urbania Mini Bus for Corporate Pune",
      "description": "Urbania Mini Bus for Corporate Pune is tailored to meet the demanding travel schedules of businesses, offering dependable transportation solutions for employee shuttles, client visits, and corporate events. These mini buses feature spacious interiors, Wi-Fi connectivity, and air conditioning to create a comfortable and productive environment on the move. With professional drivers, timely pickups, and flexible rental plans, this service supports seamless corporate travel logistics while maintaining high standards of safety and reliability. It’s an ideal choice for companies looking to ensure efficient and professional transport for their teams."
    },
    {
      "name": "Urbania Mini Bus for Wedding Pune",
      "description": "Make your special day even more memorable with Urbania Mini Bus for Wedding Pune, providing elegantly decorated mini buses equipped with plush interiors and premium amenities. Designed to transport guests comfortably and stylishly, these buses offer timely pickups, personalized decoration options, and attentive chauffeurs dedicated to ensuring smooth logistics throughout your wedding events. From pre-wedding functions to receptions, this service guarantees a luxurious and hassle-free travel experience for you and your guests, combining reliability with festive charm."
    },
    {
      "name": "Urbania Mini Bus for Outstation Pune",
      "description": "Urbania Mini Bus for Outstation Pune specializes in long-distance group travel, offering comfortable and spacious mini buses suitable for weekend getaways, business trips, and leisure tours beyond Pune. These vehicles feature ample luggage space, ergonomic seating, and modern safety equipment, ensuring a relaxed journey over extended distances. Drivers experienced with intercity routes provide punctual and secure travel, allowing passengers to enjoy scenic drives without stress. Flexible booking options and customer-centric service make this ideal for groups seeking efficient and enjoyable outstation transport."
    },
    {
      "name": "Urbania Mini Bus for Family Trip Pune",
      "description": "Urbania Mini Bus for Family Trip Pune is perfect for large families and group vacations, providing roomy and comfortable mini buses designed to enhance your travel experience. Equipped with air conditioning, entertainment systems, and safety features, these mini buses ensure everyone from children to elders travels in comfort. Professional drivers focus on creating a relaxed and safe journey, accommodating your itinerary and stops along the way. Whether it’s a city tour or a countryside retreat, this service delivers convenience, flexibility, and memorable moments for family travelers."
    },
    {
      "name": "Force Urbania Booking Pune",
      "description": "Force Urbania Booking Pune offers a seamless and user-friendly platform to reserve your preferred Force Urbania mini bus with instant confirmation and multiple payment options. Customers can customize their routes, select vehicle types, and schedule pickups that align with their specific travel plans. The service ensures transparency in pricing, round-the-clock customer support, and easy modifications to bookings, making it convenient for both planned trips and last-minute travel needs. With a commitment to quality and punctuality, Force Urbania Booking Pune simplifies the rental process from start to finish."
    },
    {
      "name": "Luxury Mini Bus Hire in Baner",
      "description": "Luxury Mini Bus Hire in Baner caters to the upscale travel demands of Baner residents and visitors, offering premium mini buses with elegant interiors, advanced climate control, and superior comfort. This service is ideal for corporate events, weddings, and exclusive tours where style and comfort are paramount. Drivers are trained for professionalism and discretion, ensuring a smooth and dignified ride. With flexible booking options and dedicated customer service, this rental provides a hassle-free, luxury transport experience within and beyond the Baner area."
    },
    {
      "name": "Urbania Mini Bus in Hinjewadi",
      "description": "Urbania Mini Bus in Hinjewadi specializes in meeting the transport needs of Pune’s IT and corporate hub, providing reliable, punctual, and comfortable mini bus services for daily commutes, client meetings, and corporate outings. Vehicles are maintained to high safety and cleanliness standards, equipped with modern amenities suited for professional travelers. Experienced drivers familiar with local traffic patterns ensure efficient route navigation, helping businesses and professionals manage their schedules seamlessly. This service offers flexible timings and competitive rates tailored for the dynamic demands of the Hinjewadi area."
    },
    {
      "name": "Affordable Urbania Mini Bus Pune",
      "description": "Affordable Urbania Mini Bus Pune is dedicated to offering cost-effective transportation solutions without compromising on quality or safety. Targeted at budget-conscious groups such as schools, startups, and small families, this service provides well-maintained mini buses with necessary amenities. The rental process is straightforward, with flexible packages and transparent pricing. Professional drivers and reliable vehicles ensure that even on a budget, passengers experience safe, timely, and comfortable travel options for city commutes and outstation trips alike."
    },
    {
      "name": "Urbania Coach Pune",
      "description": "Urbania Coach Pune offers a premium fleet of mini buses and coaches tailored for group travel, including tourist excursions, corporate tours, and special events. These vehicles combine comfort, safety, and modern features such as Wi-Fi, entertainment systems, and spacious seating. Skilled drivers prioritize passenger convenience and timely service, making every journey smooth and enjoyable. Whether for short city routes or extended tours, Urbania Coach Pune stands out for its professionalism, well-maintained fleet, and customer-centric approach."
    },
    {
      "name": "Force Urbania Tour Bus Pune",
      "description": "Force Urbania Tour Bus Pune specializes in guided tours and leisure travel, providing mini buses equipped with amenities that enhance the sightseeing experience. Spacious seating, ample luggage space, and experienced drivers who double as local guides ensure a memorable journey. This service caters to tourists and groups exploring Pune and its surroundings, offering customizable tour packages, flexible schedules, and knowledgeable support to make every trip informative and comfortable. Whether it’s a city tour or an outstation adventure, this service delivers convenience and enjoyment."
    },
    {
      "name": "Premium Urbania Rental Pune",
      "description": "Premium Urbania Rental Pune caters to clients seeking luxury and exclusivity in their transportation, providing high-end mini buses with superior interiors, advanced safety features, and top-notch amenities. Ideal for VIP clients, corporate executives, and special occasions, this service ensures exceptional comfort and personalized attention. The fleet is maintained meticulously, and drivers are trained for professionalism and discretion. With flexible rental terms, online booking options, and dedicated customer support, Premium Urbania Rental Pune promises a first-class travel experience."
    },
    {
      "name": "Urbania Mini Bus near Me Pune",
      "description": "Urbania Mini Bus near Me Pune ensures quick and convenient access to mini bus rentals throughout Pune, offering prompt availability for immediate and scheduled travel needs. This localized service emphasizes fast response times, flexible rental durations, and professional drivers to facilitate safe, comfortable, and hassle-free group transportation. Whether for urgent corporate commutes, family outings, or event travel, customers benefit from easy booking processes, competitive pricing, and reliable vehicles positioned near their location for maximum convenience."
    }
  ],
  "tableData": [
    ["Force Urbania Luxury Mini Bus On Rent", "Luxury Urbania Mini Bus Pune"],
    ["Force Urbania AC Mini Bus Pune", "Non AC Urbania Mini Bus Pune"],
    ["Urbania Mini Bus Hire Pune", "Urbania Mini Bus Rental Pune"],
    ["Urbania Mini Bus for Corporate Pune", "Urbania Mini Bus for Wedding Pune"],
    ["Urbania Mini Bus for Outstation Pune", "Urbania Mini Bus for Family Trip Pune"],
    ["Force Urbania Booking Pune", "Luxury Mini Bus Hire in Baner"],
    ["Urbania Mini Bus in Hinjewadi", "Affordable Urbania Mini Bus Pune"],
    ["Urbania Coach Pune", "Force Urbania Tour Bus Pune"],
    ["Premium Urbania Rental Pune", "Urbania Mini Bus near Me Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Force Urbania Luxury Mini Bus On Rent",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers premium Force Urbania luxury mini bus rentals, combining comfort and style for group travel."
  },
  {
    "WhyChooseheading": "Luxuriously Equipped Interiors",
    "WhyChoosedescription": "Our luxury mini buses feature plush seating, ample legroom, air conditioning, and modern amenities for a superior travel experience."
  },
  {
    "WhyChooseheading": "Regular Maintenance and Sanitization",
    "WhyChoosedescription": "All vehicles are meticulously maintained and sanitized to ensure safety, cleanliness, and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from upfront pricing with no hidden charges, offering excellent value for luxury transportation."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your specific travel needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous drivers provide safe, punctual, and smooth journeys every time."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, inquiries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Force Urbania luxury mini bus easily online or via phone, with prompt and reliable service."
  }
]









  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Force Urbania luxury mini bus rental services?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Force Urbania luxury mini buses on rent, ideal for comfortable and stylish group travel.',
  },
  {
    question: 'How can I rent a Force Urbania luxury mini bus with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What amenities are available in the Force Urbania luxury mini buses?',
    answer: 'Our Force Urbania luxury mini buses feature plush seating, air conditioning, entertainment systems, and essential safety features for a premium travel experience.',
  },
  {
    question: 'Are the drivers experienced and professional for Force Urbania luxury mini bus rentals?',
    answer: 'Yes, all drivers are trained, courteous, and experienced in providing safe and smooth rides in luxury mini buses.',
  },
  {
    question: 'Can Force Urbania luxury mini buses be hired for weddings, corporate events, tours, and airport transfers?',
    answer: 'Absolutely. These luxury mini buses are perfect for weddings, corporate outings, sightseeing tours, airport transfers, and other special occasions.',
  },
  {
    question: 'Is the Force Urbania luxury mini bus rental service available 24×7?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Force Urbania luxury mini bus rentals to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for Force Urbania luxury mini bus rentals?',
    answer: 'All vehicles are thoroughly sanitized before every trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for Force Urbania luxury mini bus rentals?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the Force Urbania luxury mini bus rental period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Mehta',
    feedback: 'The Force Urbania luxury mini bus from Amruta Travels was spacious and comfortable with excellent service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Reddy',
    feedback: 'Amazing experience renting the Force Urbania luxury mini bus for our corporate event. Highly recommended!',
    rating: 5,
  },
];











































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania Luxury Mini Bus On Rent",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/26.jpg",
  "description": "Rent a Force Urbania Luxury Mini Bus in Pune with Amruta Travels Pvt. Ltd. Offering AC and Non-AC mini buses for corporate, wedding, family trips, and outstation travel. Affordable and premium Urbania mini bus rental service.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.89",
    "ratingCount": "13892"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/force-urbania-luxury-mini-bus-on-rent"
  }
};





  return (
    <div>

<Helmet>
  <title>Force Urbania Luxury Mini Bus On Rent | Urbania Mini Bus Hire Pune | Amruta Travels</title>
  <meta
    name="description"
    content="Rent a Force Urbania Luxury Mini Bus in Pune with Amruta Travels Pvt. Ltd. Offering AC and Non-AC mini buses for corporate, wedding, family trips, and outstation travel. Affordable and premium Urbania mini bus rental."
  />
  <meta
    name="keywords"
    content="Force Urbania Luxury Mini Bus On Rent, Luxury Urbania Mini Bus Pune, Force Urbania AC Mini Bus Pune, Non AC Urbania Mini Bus Pune, Urbania Mini Bus Hire Pune, Urbania Mini Bus Rental Pune, Urbania Mini Bus for Corporate Pune, Urbania Mini Bus for Wedding Pune, Urbania Mini Bus for Outstation Pune, Urbania Mini Bus for Family Trip Pune, Force Urbania Booking Pune, Luxury Mini Bus Hire in Baner, Urbania Mini Bus in Hinjewadi, Affordable Urbania Mini Bus Pune, Urbania Coach Pune, Force Urbania Tour Bus Pune, Premium Urbania Rental Pune, Urbania Mini Bus near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbanialuxuryminibusonrent;